// 资源基址（图片、虚拟礼物下载链接等都以它为前缀拼接）。
//
// 取值优先级：
//   1) 构建时注入的 VUE_APP_ASSET_BASE（在 .env.production 里配置，见 .env.example）
//   2) 兜底：跟随当前页面域名 —— window.location.origin
//
// 为什么兜底改成 origin：以前兜底是写死的 http://101.35.160.213:3001，
// 页面走 HTTPS 时被浏览器按混合内容拦掉，全站图片直接打不开；
// 而且换域名 / 加 SSL 都得重新打包。改成 origin 后由 nginx 把
// /avataruploads/、/uploads/ 反代到后端 3001，同源即可访问。
export const ASSET_BASE = (() => {
    const configured = (process.env.VUE_APP_ASSET_BASE || '').trim();
    if (configured) return configured.replace(/\/+$/, '');

    try {
        if (typeof window !== 'undefined' && window.location && window.location.origin) {
            return window.location.origin;
        }
    } catch (e) {
        // 极端环境下拿不到 window，退成空串（等价于同源相对路径）
    }
    return '';
})();
